import {Component, ElementRef, Input, ViewChild} from '@angular/core';
import { AlertController, AnimationController, IonContent } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { zip } from 'rxjs';

@Component({
  selector: 'accordion',
  templateUrl: 'accordion.html',
  styleUrls: ['accordion.scss'],
})
export class AccordionComponent {

  @Input('title') public title: string;
  @Input('icon') public iconName: string;
  @Input('expanded') public expanded: boolean = false;
  @Input('content') public content: IonContent;
  @Input('help') public help: string;

  @ViewChild('header', { read: ElementRef }) private header: ElementRef;
  @ViewChild('body', { read: ElementRef }) private body: ElementRef;
  @ViewChild('container', { read: ElementRef }) private container: ElementRef;

  private didExpand: boolean = false;

  constructor(
    private animationCtrl: AnimationController,
    private translateService: TranslateService,
    private alertCtrl: AlertController,
    ) { }

  @Input() public set autoExpand(autoExpand: number) {
    if (autoExpand > 0 ) {
      setTimeout(() => this.checkAutoExpand(), autoExpand);
    }
  }

  public toggle(): void {
    this.expanded = !this.expanded;
    this.didExpand = true;
    const animation = this.animationCtrl.create('toggle-animation')
      .addElement(this.body.nativeElement)
      .duration(400)
      .easing('ease-out');
    const h: number = this.container.nativeElement.offsetHeight;
    if ( this.expanded) {
      animation.fromTo('height', '0px',  h + 'px');
    } else {
      animation.fromTo('height', h + 'px', '0px');
    }
    animation
//    .afterAddRead(() => { this.content.scrollToPoint(0, this.container.nativeElement.getBoundingClientRect().y, 400)})
    .play();
    setTimeout(() => {
      if (this.content !== undefined) {
        this.content.scrollByPoint(0, this.header.nativeElement.getBoundingClientRect().y - 64, 400);
      }
      // set height to auto again, because inner conten may change size
      if ( this.expanded) {
        this.animationCtrl.create('toggle-animation2')
          .addElement(this.body.nativeElement)
          .duration(10)
          .fromTo('height', h + 'px', 'auto')
          .play();
      }

    }, 410);
  }

  private checkAutoExpand(): void {
    if (!this.didExpand && !this.expanded) {
      this.toggle();
    }
  }

  public async showHelp(event: Event): Promise<void> {
    event.stopPropagation();
    zip(
      this.translateService.get('COMMON.HELP'),
      this.translateService.get('COMMON.OK'),
    ).subscribe(async(translations) => {
      const alert = await this.alertCtrl.create({
        cssClass: 'regular-alert',
        header: translations[0],
        buttons: [translations[1]],
        // tslint:disable-next-line:no-magic-numbers
        message: this.help,
        backdropDismiss: true,
        animated: true,
      });
      alert.present();
    });
  }

}
